import elementZh from 'element-ui/src/locale/lang/zh-CN'
import _ from "lodash";

export default _.merge(elementZh, {
  el: {
    datepicker: {
      months: {
        jan: '一期',
        feb: '二期',
        mar: '三期',
        apr: '四期',
        may: '五期',
        jun: '六期',
        jul: '七期',
        aug: '八期',
        sep: '九期',
        oct: '十期',
        nov: '十一期',
        dec: '十二期',
      },
	 now: '此刻',
	 today: '本月',
	 cancel: '取消',
	 clear: '清空',
	 confirm: '确定',
	 selectDate: '选择日期',
	 selectTime: '选择时间',
	 startDate: '开始日期',
	 startTime: '开始时间',
	 endDate: '结束日期',
	 endTime: '结束时间',
	 prevYear: '前一年',
	 nextYear: '后一年',
	 prevMonth: '上月',
	 nextMonth: '下月',
	 year: '年',
	 month1: '1 月',
	 month2: '2 月',
	 month3: '3 月',
	 month4: '4 月',
	 month5: '5 月',
	 month6: '6 月',
	 month7: '7 月',
	 month8: '8 月',
	 month9: '9 月',
	 month10: '10 月',
	 month11: '11 月',
	 month12: '12 月',
	 // week: '周次',
	 weeks: {
	   sun: '日',
	   mon: '一',
	   tue: '二',
	   wed: '三',
	   thu: '四',
	   fri: '五',
	   sat: '六'
	 },
    }
  }
})